// extracted by mini-css-extract-plugin
export default {"dialog_inner":"Tag_dialog_inner__vCMs2","dialog_header":"Tag_dialog_header__rNVUH"};